import { useMutation } from 'react-query';

import { changePassword } from '../../lib/api';

export function useMutateChangePassword() {
  return useMutation(changePassword);
}
